import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import { TriangleAlert } from 'lucide-react';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';

interface OrderPriceTableConflictModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const OrderPriceTableConflictModal = ({
  isOpen,
  onClose,
  onConfirm,
}: OrderPriceTableConflictModalProps) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="compact"
      header={{
        title: translate(LangEnum.ORDER_ALLOW_UPDATE_PRICE_TABLE_MODAL_TITLE),
        icon: TriangleAlert,
      }}
      footer={{
        primaryAction: {
          label: translate(LangEnum.ORDER_ALLOW_UPDATE_PRICE_TABLE_MODAL_CONFIRM_LABEL),
          onClick: onConfirm,
        },
        secondaryAction: {
          label: translate(LangEnum.ORDER_ALLOW_UPDATE_PRICE_TABLE_MODAL_CANCEL_LABEL),
          onClick: onClose,
        },
      }}
    >
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        {translate(LangEnum.ORDER_ALLOW_UPDATE_PRICE_TABLE_MODAL_DESCRIPTION)}
      </Typography>
    </Modal>
  );
};

export default OrderPriceTableConflictModal;
